import { Instance } from 'mobx-state-tree';
import { VisitActionDtoModelBase } from './VisitActionDtoModel.base';

/* The TypeScript type of an instance of VisitActionDtoModel */
export interface VisitActionDtoModelType extends Instance<typeof VisitActionDtoModel.Type> {}

/* A graphql query fragment builders for VisitActionDtoModel */
export { selectFromVisitActionDto, visitActionDtoModelPrimitives, VisitActionDtoModelSelector } from './VisitActionDtoModel.base';

/**
 * VisitActionDtoModel
 */
export const VisitActionDtoModel = VisitActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
